// 医生随访
// 临观随访
import { handlePlanType, filterTime } from '@/utils'
const BASE_LABEL = [
  {
    label: '随访ID: ',
    prop: 'followupPlanId',
    nopadding: true
  },
  {
    label: '计划名称: ',
    prop: 'planName'
  },
  {
    label: '医生ID: ',
    prop: 'doctorId',
    noborder: true
  },
  {
    label: '医生姓名: ',
    prop: 'doctorName',
    nopadding: true
  },
  {
    label: '患者ID: ',
    prop: 'patientProfileCommonVO',
    render: text => {
      return text?.patientProfileId || '--'
    }
  },
  {
    label: '患者姓名: ',
    prop: 'patientProfileCommonVO',
    noborder: true,
    render: text => text?.patientProfileName || '--'
  },
  {
    label: '随访类型: ',
    prop: 'planType',
    nopadding: true,
    render: it => handlePlanType(it)
  },

  {
    label: '随访状态: ',
    prop: 'planStatus'
  },
  {
    label: '开始时间: ',
    prop: 'beginTime',
    noborder: true,
    render: it => filterTime({ text: it })
  },
  {
    label: '结束时间: ',
    prop: 'endTime',
    nopadding: true,
    class: 'huge',
    noborder: true,
    render: it => filterTime({ text: it })
  }
]
// 随访阶段
const visitDateColumn = [
  {
    title: '随访阶段',
    dataIndex: 'stageName',
    key: 'stageName',
    customRender: ({ text }) => {
      return text || '--'
    }
  },

  {
    title: '推送状态',
    dataIndex: 'pushStatus',
    key: 'pushStatus',
    customRender: ({ text }) => {
      return text || '--'
    }
  },
  {
    title: '随访时间',
    dataIndex: 'followDate',
    key: 'followDate',
    width: 180,
    customRender: ({ text }) => {
      return text || '--'
    }
  }
]
export default {
  BASE_LABEL,
  visitDateColumn
}
